import axios from 'axios';
import { get, post, put } from './client';
import { makeGrowerPath } from './utils';

export function putUpdatedCropType(aaids, year, crop) {
  return put(makeGrowerPath('/planting/updateCrop'), { aaids, year, crop });
}

export function getPlantingUploadUrl(growerId, fileName) {
  return post(`/growers/planting/upload/${growerId}/get-signed-upload-url`, {
    fileName,
  });
}

export function uploadPlantingToS3(signedUrl, file, onProgress) {
  return axios.put(signedUrl, file, {
    headers: { 'Content-Type': 'application/zip' },
    onUploadProgress: (progressEvent) => onProgress(file.name, progressEvent),
  });
}

export function uploadPlantingToAgi(growerId, fileUrl, fileName) {
  return post(`/${growerId}/planting/conversions`, {
    fileUrl,
    fileName,
  });
}

export function getPlantingDownloadUrl(growerId, fileName) {
  return post(`/growers/planting/upload/${growerId}/get-signed-url`, {
    fileName,
  });
}

export function getRawPlantingForGrower(growerId, year) {
  return get(`/planting/raw/by-grower/${growerId}?year=${year}`);
}

export function getCleanPlantingForGrower(growerId, year) {
  return get(`/planting/clean/by-grower/${growerId}?year=${year}`);
}

export function getRawPlantingRawForAaid(aaid, year) {
  return get(makeGrowerPath(`/planting/raw-by-rate/${aaid}?year=${year}`));
}

export function postPlantingCleaningRequest(growerId, year, aaids) {
  return post(makeGrowerPath('/planting/clean'), { growerId, year, aaids });
}

export function putApproveCleanField(aaid, year, approved) {
  return put(makeGrowerPath('/planting/approve'), { aaid, year, approved });
}

export function putStandardPlantingProducts(fieldProducts, year, growerId) {
  return put(makeGrowerPath('/planting/product-standardize'), {
    fieldProducts,
    year,
    growerId,
  });
}

export function addNewProduct(product) {
  return post(makeGrowerPath('/planting/products'), { product });
}

export function getPlantingProductOverrides(growerId, year, aaids) {
  return get(`/planting/products/overrides/${growerId}/${year}`, {
    paramsSerializer: { indexes: null },
    params: { aaid: aaids },
  });
}
